<template>
  <div id="unacknowledged-entries" v-if="isSignedIn">
    <a-button @click="acknowledgeSelectedEntries" :disabled="!hasSelected" :loading="isLoadingAcknowledge"
      >Acknowledge Selected ({{ selectedRows.length }})
    </a-button>
    <a-table
      :columns="columns"
      :data-source="unackedClscEntries"
      class="components-table-demo-nested"
      :pagination="false"
      :rowKey="(record) => record.id"
      :loading="isLoading"
      :row-selection="{ onChange: onSelectChange }"
    >
      <div class="center-col" slot="workday_emp_id" slot-scope="value">{{ value }}</div>
      <div class="center-col" slot="employee_name" slot-scope="value">{{ value }}</div>
      <div class="center-col" slot="date_performed" slot-scope="value">
        {{ value ? formatDateMMDDYYYY(value) : "" }}
      </div>
      <div class="center-col" slot="hours" slot-scope="value">{{ getEntryHours(value) }}</div>
      <div class="center-col" slot="status" slot-scope="status, record">
        {{ status }}
        <a-popover v-if="record.error_message != ''" :title="status">
          <template slot="content">
            <p>{{ record.error_message }}</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </div>
      <div class="center-col" slot="entry_type" slot-scope="value">{{ value }}</div>
      <div class="center-col" slot="expandedRowRender" slot-scope="record">
        <raw-time-entries
          :batchId="record.batch_id"
          :workday-emp-id="record.workday_emp_id"
          :date-performed="record.date_performed"
          :entry-type="record.entry_type"
          :pto-subtype="record.pto_subtype"
        />
      </div>
    </a-table>
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import RawTimeEntries from "./RawTimeEntries";

const columns = [
  {
    title: "Employee ID",
    dataIndex: "workday_emp_id",
    key: "workday_emp_id",
    scopedSlots: { customRender: "workday_emp_id" },
  },
  {
    title: "Employee Name",
    dataIndex: "employee_name",
    key: "employee_name",
    scopedSlots: { customRender: "employee_name" },
  },
  {
    title: "Date Performed",
    dataIndex: "date_performed",
    key: "date_performed",
    scopedSlots: { customRender: "date_performed" },
  },
  {
    title: "No. of Hours",
    dataIndex: "total_minutes",
    key: "hours",
    scopedSlots: { customRender: "hours" },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "Entry Type",
    dataIndex: "entry_type",
    key: "entry_type",
    scopedSlots: { customRender: "entry_type" },
    filters: [
      {
        text: "Worked Time",
        value: "Worked Time",
      },
      {
        text: "PTO",
        value: "PTO",
      },
    ],
    filterMultiple: false,
    onFilter: (value, record) => record.entry_type === value,
  },
];

export default {
  name: "UnacknowledgedEntries",
  components: { RawTimeEntries },
  computed: {
    ...mapState(["apiUrl"]),
    ...mapGetters("auth", ["isSignedIn", "getUUID"]),
    hasSelected() {
      return this.selectedRows.length > 0;
    },
  },
  data() {
    return {
      columns,
      unackedClscEntries: [],
      selectedRows: [],
      selectedRowKeys: [],
      isLoading: false,
      isLoadingAcknowledge: false,
    };
  },
  methods: {
    ...mapMutations("auth", ["signInFailed"]),
    fetchUnackedEntries() {
      this.isLoading = true;
      axios({
        url: `${this.apiUrl}/getBatchEntries`,
        params: {
          action: "FETCH_BATCH_UNACKED_ENTRIES",
          batchId: this.batchId,
        },
        headers: {
          Authorization: "Bearer " + this.getUUID,
        },
      })
        .then((rslt) => {
          this.unackedClscEntries = rslt.data;
          this.selectedRows = [];
          this.selectedRowKeys = [];
          this.isLoading = false;
          this.isLoadingAcknowledge = false;
        })
        .catch((err) => {
          //In the case the endpoint returns a 401, that means
          // our session token has expired. Reroute to /sso-login
          if (err.response.status == 401) {
            this.signInFailed("Session has expired.");
            this.$router.push(`/sso-login`);
          } else {
            alert("Unable to load entries");
            this.isLoading = false;
            this.isLoadingAcknowledge = false;
          }
        });
    },
    acknowledgeSelectedEntries() {
      this.isLoadingAcknowledge = true;
      // Pass only the id and entry_type fields
      const clscEntryParams = this.selectedRows.map((row) => {
        return { id: row.id, entry_type: row.entry_type };
      });
      console.log("acknowledgeBatchEntries params: ", this.batchId, clscEntryParams);
      axios({
        method: "post",
        url: `${this.apiUrl}/acknowledgeBatchEntries`,
        params: {
          batchId: this.batchId,
          coalescedEntries: JSON.stringify(clscEntryParams),
        },
        headers: {
          Authorization: "Bearer " + this.getUUID,
        },
      })
        .then((resp) => {
          this.fetchUnackedEntries();
        })
        .catch((err) => {
          //In the case the endpoint returns a 401, that means
          // our session token has expired. Reroute to /sso-login
          if (err.response.status == 401) {
            this.signInFailed("Session has expired.");
            this.$router.push(`/sso-login`);
          } else {
            alert("Unable to acknowledge");
            this.fetchUnackedEntries();
          }
        });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      console.log("selectedRow changed: ", selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    formatDateMMDDYYYY(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    // Round-up to 2 decimal places
    getEntryHours(minutes) {
      return Math.round((minutes / 60) * 100) / 100;
    },
  },
  mounted() {
    this.isLoading = true;
    this.fetchUnackedEntries();
  },
  props: ["batchId"],
};
</script>

<style lang="scss" scoped></style>
